import service from "@/utils/request";
export interface lessonList {
  page: number;
  page_size: number;
  start_date: string;
  end_date: string;
  class_id?: number;
  student_id?: number;
  roll_call_status?: number;
  sort_type?: string;
  sort_field?: string;
}
export interface rollcallist {
  page?: number;
  page_size?: number;
  roll_call_id?: number;
  student_id?: number;
  roll_call_start_date?: string;
  roll_call_end_date?: string;
  lesson_start_date?: string;
  lesson_end_date?: string;
  teacher_id?: number;
  course_id?: number;
  class_id?: number;
  student_status?: number;
  sort_type?: string;
  sort_field?: string;
  subject_ids?: [];
  classroom_id?: number;
  staff_id?: string;
  course_type?: number;
  status?: number;
  exceed_status?: number;
}
export interface followAddData {
  student_id?: number;
  student_follow_id?: number;
  mode?: number;
  stage?: number;
  intent?: number;
  content?: string;
  follow_content?: string;
  follow_time?: number;
  images?: string[];
}
// 学员详情
export const studentDetail = (params: { student_id: number }) => {
  return service({
    url: "/api/v1/student/detail",
    method: "get",
    params,
  });
};
// 学员里程碑
export const studentMilestoneApi = (params: { student_id: number }) => {
  return service({
    url: "/api/v1/student/milestone/list",
    method: "get",
    params,
  });
};
//学员课程列表
export const courseList = (params: { student_id: number }) => {
  return service({
    url: "/api/v1/student/course/list",
    method: "get",
    params,
  });
};
//学员删除
export const deldetails = (data: { student_ids: number[] }) => {
  return service({
    url: "/api/v1/student/del",
    method: "post",
    data,
  });
};
// 结课
export const getcourseFinish = (data: {
  account_id: number;
  force: number;
}) => {
  return service({
    url: "/api/v1/student/course/finish",
    method: "post",
    data,
  });
};
// 撤销结课
export const cancelCourseFinishApi = (data: { completion_id: number }) => {
  return service({
    url: "/api/v1/student/course/cancel_finish",
    method: "post",
    data,
  });
};
// 停课
export const getcourseFreeze = (data: {
  account_id: number;
  start_time: number;
  end_time: number;
}) => {
  return service({
    url: "/api/v1/student/course/freeze",
    method: "post",
    data,
  });
};
// 复课
export const getcourseUnfreeze = (data: {
  stop_id: number;
  end_time: number;
}) => {
  return service({
    url: "/api/v1/student/course/unfreeze",
    method: "post",
    data,
  });
};
// 停课记录
export const getfreezerecord = (params: { account_id: number }) => {
  return service({
    url: "/api/v1/student/course/get_freeze_record",
    method: "get",
    params,
  });
};
// 课时清零
export const postorderclean = (data: { order_item_course_id: number }) => {
  return service({
    url: "/api/v1/student/course/order_clean",
    method: "post",
    data,
  });
};
// 待点名课时
export const getlessonlist = (params: lessonList) => {
  return service({
    url: "/api/v1/class/lesson/list",
    method: "get",
    params,
  });
};
// 跟进记录
export const getfollowlist = (params: { student_id: number }) => {
  return service({
    url: "/api/v1/student/follow/list",
    method: "get",
    params,
  });
};
// 删除跟进记录
export const getfollowdel = (data: { follow_id: number }) => {
  return service({
    url: "/api/v1/student/follow/del",
    method: "post",
    data,
  });
};
// 跟进记录方式
export const getfollowmode = () => {
  return service({
    url: "/api/v1/student/follow/mode",
    method: "get",
  });
};
// 跟进记录阶段
export const getfollowstage = () => {
  return service({
    url: "/api/v1/student/follow/stage",
    method: "get",
  });
};
// 跟进记录意向
export const getfollowintent = () => {
  return service({
    url: "/api/v1/student/follow/intent",
    method: "get",
  });
};
// 添加跟进记录
export const getfollowadd = (data: followAddData) => {
  return service({
    url: "/api/v1/student/follow/add",
    method: "post",
    data,
  });
};
// 编辑跟进记录
export const getfollowedit = (data: followAddData) => {
  return service({
    url: "/api/v1/student/follow/edit",
    method: "post",
    data,
  });
};
// 取消跟进记录
export const getfollowclose = (data: followAddData) => {
  return service({
    url: "/api/v1/student/follow/cancel",
    method: "post",
    data,
  });
};
// 点名学员记录统计
export const getstudentcount = (params: rollcallist) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/student/count",
    method: "get",
    params,
  });
};
// 修改学员
export interface addStudentData {
  name: string;
  mobile: string;
  avatar?: string;
  mobile_relation?: number;
  sex?: number;
  birthday?: number;
  age?: number;
  guardian_relation?: number;
  guardian_mobile?: string;
  home_address?: string;
  remark?: string;
  source_type?: number;
  teacher_id?: number;
  follow_staff_id?: number;
}
export const studentedit = (data: addStudentData) => {
  return service({
    url: "/api/v1/student/edit",
    method: "post",
    data,
  });
};
//导出列表
export interface exportData {
  roll_call_id?: number;
  student_id?: number;
  roll_call_start_date?: string;
  roll_call_end_date?: string;
  lesson_start_date?: string;
  lesson_end_date?: string;
  teacher_id?: number;
  course_id?: number;
  class_id?: number;
  student_status?: number;
  exceed_status?: number;
  status?: number;
  market_staff_id?: number;
}
//导出
export const exportStudentroll = (params: exportData) => {
  return service({
    url: "/api/v1/class/lesson/roll_call/student/export",
    method: "get",
    params,
  });
};
//修改课程时间
export const set_expire_time = (data: {
  order_item_course_id?: number;
  end_time?: number;
}) => {
  return service({
    url: "/api/v1/student/course/set_expire_time",
    method: "post",
    data,
  });
};
export interface studentCompletionInter {
  student_id: number;
  completion_category_id: number;
  completion_remark?: string;
  force?: number;
}
//结业
export const studentCompletion = (data: studentCompletionInter) => {
  return service({
    url: "/api/v1/student/completion",
    method: "post",
    data,
  });
};

// 学员超上课程列表
export const studentExceedListApi = (data: {
  student_id: number;
  course_ids?: number[];
}) => {
  return service({
    url: "/api/v1/student/course/exceed_list",
    method: "post",
    data,
  });
};

// 学员超上补扣
export const studentExceedHandleApi = (data: {
  student_id: number;
  course_ids: number[];
}) => {
  return service({
    url: "/api/v1/student/course/exceed_handle",
    method: "post",
    data,
  });
};

// 学员家庭详情
export const studentFamilyInfoApi = (params: { student_id: number }) => {
  return service({
    url: "/api/v1/family/detail",
    method: "get",
    params,
  });
};

// 学员详情-活跃总计
export const getStudentActivationTotalApi = (params: {
  student_id: number;
  start_date: string;
  end_date: string;
}) => {
  return service({
    url: "/api/v1/student/active/total",
    method: "get",
    params,
  });
};
// 学员详情-活跃明细
export const getStudentActivationDetailApi = (params: {
  student_id: number;
  start_date: string;
  end_date: string;
}) => {
  return service({
    url: "/api/v1/student/active/list",
    method: "get",
    params,
  });
};
export interface getDynamicListData {
  page: number;
  page_size: number;
  student_id: number;
  log_type: string;
  start_time: string;
  end_time: string;
}
// 学员动态
export const getDynamicListApi = (params: getDynamicListData) => {
  return service({
    url: "/api/v1/student/dynamic_list",
    method: "get",
    params,
  });
};

// 学员耗课次数占比
export const getConsumeCountRateApi = (params: {
  start_date: string;
  end_date: string;
}) => {
  return service({
    url: "/api/v1/statistics/student/consume_count_rate",
    method: "get",
    params,
  });
};
